import columns from './tableConfig'
import { searchItems } from './searchFormConfig'
import { indexUserServiceChangeLog } from '../../../api/userMana'

let searchCache = {}

const payTypes = {
  1: {
    'code': 1,
    'name': '微信扫码'
  },
  2: {
    'code': 2,
    'name': '支付宝扫码'
  }
}

const chargeTypeList = {
  1: {
    name: '购买',
    tagStyle: 'blue'
  },
  2: {
    name: '赠送',
    tagStyle: 'cyan'
  },
  3: {
    name: '退款',
    tagStyle: 'orange'
  },
  4: {
    name: '其他',
    tagStyle: 'purple'
  },
  5: {
    name: '使用',
    tagStyle: 'green'
  },
}

const billingServiceTypes = [
  {
    'code': 10101,
    'name': '门禁机云平台服务'
  },
  {
    'code': 10102,
    'name': '门禁机物联网卡服务'
  },
  {
    'code': 10201,
    'name': '访客机云平台服务'
  },
  {
    'code': 10202,
    'name': '访客机物联网卡服务'
  },
  {
    'code': 1,
    'name': '用户业务短信条数'
  }
]

let typeList = billingServiceTypes.reduce((typeList, item) => {
  typeList[item.code] = item.name;
    return typeList;
  }, {});

export default {
  name: 'ServiceLog',
  components: {},
  data() {
    return {
      searchItems,
      searching: false,
      columns,
      payTypes,
      chargeTypeList,
      data: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      states: {
        0: '启用',
        1: '禁用'
      },
      showEditAppModal: false,
      showAddNumberModal: false,
      showDetailDrawer: false,
      targetApp: null,
      targetTerminal: null,
      typeList,
    }
  },
  created() {
    this.$nextTick(async () => {
      this.indexUserServiceChangeLog()
    })
  },

  methods: {
    // 查询应用
    async indexUserServiceChangeLog(page = 1, searchData) {
      try {
        this.loading = true
        // 确定搜索条件
        searchData = searchData || searchCache
        // 缓存搜索条件
        searchCache = searchData
        let {
          transactionNo,
          dateTimeRange
        } = searchData

        let from, to
        if (dateTimeRange && dateTimeRange.length) {
          from = dateTimeRange[0].format('YYYY-MM-DD HH:mm:ss')
          to = dateTimeRange[1].format('YYYY-MM-DD HH:mm:ss')
        }

        await indexUserServiceChangeLog({
          from,
          to,
          page,
          perPage: this.pagination.pageSize
        }).then(res => {
          let data = res.data.collection
          this.data = data.map(app => Object.assign(app, { key: app.id }))
          this.pagination.current = page
          this.pagination.total = res.data.size
        })
      } catch (error) {
      }
      this.loading = this.searching = false
    },
    // 翻页
    handlePageTurn(pagination, filters, sorter) {
      const { current } = pagination
      this.indexUserServiceChangeLog(current)
    },
    // 打开应用详情抽屉弹窗
    handlerDetailDrawer(data) {
      this.targetTerminal = data
      this.showDetailDrawer = true
    },
    // 关闭应用详情抽屉弹窗
    handlerCloseDetailDrawer() {
      this.showDetailDrawer = false
      setTimeout(() => {
        this.targetTerminal = null
      }, 500)
    }
  }
}
